import styled from '@emotion/styled'

export const FormField = styled.div`
  margin-bottom: 20px;
  .default {
    color: #607d8b;
  }
`
